import { render, staticRenderFns } from "./home.vue?vue&type=template&id=3ac6b22c&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=3ac6b22c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac6b22c",
  null
  
)

export default component.exports